// ============================================================
// FilterPicker.jsx — colour filter presets for the Video Editor (v1)
// ------------------------------------------------------------
// Shows the same 32 presets as the Photo Editor (filterEngine.PRESET_FILTERS).
// Selecting one applies a CSS filter to the live preview and is passed into the
// render payload so Rendi can bake it in via FFmpeg. Each swatch previews the
// filter on a neutral gradient so the effect is visible without the clip frame.
// ============================================================

import React from 'react';
import { PRESET_NAMES, resolvePresetSettings, buildPreviewCSS } from '../../utils/filterEngine';

export default function FilterPicker({ activePreset = 'Normal', onSelect }) {
  return (
    <div className="ve-filters">
      <p className="ve-hint">
        Pick a filter to preview it on your clip — it’s baked into the video when you render.
      </p>
      <div className="ve-filter-grid">
        {PRESET_NAMES.map((name) => {
          const css = buildPreviewCSS(resolvePresetSettings(name, 1));
          const active = (activePreset || 'Normal') === name;
          return (
            <button
              key={name}
              type="button"
              className={`ve-filter-item${active ? ' active' : ''}`}
              onClick={() => onSelect?.(name)}
              title={name}
            >
              <span className="ve-filter-swatch" style={{ filter: css }} />
              <span className="ve-filter-name">{name}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
